// src/services/admin/subject-awards.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export const subjectAwardsApi = createApi({
  reducerPath: "subjectAwardsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_BASE_URL}/api/admin/subject-awards`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["SubjectAwards"],
  endpoints: (builder) => ({
    getAllSubjectAwards: builder.query({
      query: () => "",
      transformResponse: (response) => response.data || response,
      providesTags: ["SubjectAwards"],
    }),
    updateSubjectAward: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["SubjectAwards"],
    }),
    getScholarshipSubjectAwards: builder.query({
      query: (scholarshipId) => `/scholarship/${scholarshipId}`,
      transformResponse: (response) => response.data || response,
      providesTags: (result, error, scholarshipId) => [
        { type: "SubjectAwards", id: `scholarship-${scholarshipId}` },
      ],
    }),
    updateScholarshipSubjectAwards: builder.mutation({
      query: ({ scholarshipId, subjectAwardIds }) => ({
        url: `/scholarship/${scholarshipId}`,
        method: "PUT",
        body: { subject_award_ids: subjectAwardIds },
      }),
      invalidatesTags: (result, error, { scholarshipId }) => [
        { type: "SubjectAwards", id: `scholarship-${scholarshipId}` },
      ],
    }),
  }),
});

export const {
  useGetAllSubjectAwardsQuery,
  useUpdateSubjectAwardMutation,
  useGetScholarshipSubjectAwardsQuery,
  useUpdateScholarshipSubjectAwardsMutation,
} = subjectAwardsApi;
